import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, HashRouter } from 'react-router-dom';
import App from './App';
import store from './redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
    </Provider>
);

// setup(store);

// const { dispatch } = store;
// api.interceptors.response.use(
//   (config) => {
//     return config;
//   },
//   (error) => {
//     if (error.response.status === 401) {
//       //토큰이 모두 만료됐다는 응답 값을 받으면 세션스토리지를 비워줍니다.
//       // <Navigate  replace to="/login" />
//       alert('권한이 없습니다. 다시 로그인 해주세요')
//       dispatch(logout());
//       // window.location.reload();
//     }
//     return Promise.reject(error);
//   },
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals